import { Assistant, AssistantId } from "@genai/assistant";
import {
  ApiChat,
  ApiChatMessage,
  Chat,
  ChatId,
  ChatMessage,
  status,
} from "../model";
import { httpClient, postProcessUpsert } from "@genai/http-client";

export interface LoaderData {
  assistants: Assistant[];
  chats: Chat[];
  messages: ChatMessage[] | undefined;
}

export const loadChats = (assistantId: AssistantId) =>
    httpClient(`/assistants/${assistantId}/chats`, {
      method: "GET",
    }).then(postProcessUpsert<ApiChat[]>);

export const loadChat = (assistantId: AssistantId, chatId: ChatId) =>
    httpClient(`/assistants/${assistantId}/chats/${chatId}`, {
      method: "GET",
    }).then(postProcessUpsert<ApiChat>);

export const loadMessages = (assistantId: AssistantId, chatId: ChatId) =>
    httpClient(`/assistants/${assistantId}/chats/${chatId}/messages`, {
      method: "GET",
    })
      .then(postProcessUpsert<ApiChatMessage[]>)
      .then((apiChatMessages) => apiChatMessages.map(toChatMessage));


function toChatMessage(apiChatMessage: ApiChatMessage): ChatMessage {
  return {
    uuid: apiChatMessage.uuid,
    role: apiChatMessage.role,
    status: status.success,
    content: apiChatMessage.content,
    filters: apiChatMessage.filters,
  };
}
